import { render, staticRenderFns } from "./relatedProductsHua.vue?vue&type=template&id=f4dedc6e&scoped=true&"
import script from "./relatedProductsHua.vue?vue&type=script&lang=js&"
export * from "./relatedProductsHua.vue?vue&type=script&lang=js&"
import style0 from "./relatedProductsHua.vue?vue&type=style&index=0&id=f4dedc6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4dedc6e",
  null
  
)

export default component.exports